<div class="container">
	<div class="row">
		<div class="col"><hr class="mt-0"/></div>
	</div>

	<div class="row">
		<div class="col-12">
			<mat-card class="p-0">
				<div class="table-responsive">
					<table
						mat-table
						[dataSource]="paginated"
						class="w-100"
						matSort
						matSortActive="{{registrationsService.regSearchQuery.sortColumn}}"
						matSortDisableClear
						matSortDirection="{{registrationsService.regSearchQuery.sortOrder}}"
						multiTemplateDataRows
						aria-label="List of available requests">

						<ng-container matColumnDef="id">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>ID</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<button (click)="viewTransferDetails(row)" title="View Transfer Request Details" i18n-title type="button" class="button-link">{{row.id | slice:row.id.length-8:row.id.length}}</button>
							</td>
						</ng-container>

						<ng-container matColumnDef="createdAt">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Created On</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span title="Created on">{{row.createdAt | slice:0:10}}</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="bikeId">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Item #</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span title="View Bike Details." i18n-title>{{row.bikeId | slice:row.bikeId.length-8:row.bikeId.length}}</span>
								<!-- <button (click)="viewBikeDetails(row['bikeId'])" title="View Bike Details." i18n-title type="button" class="button-link">{{row.bikeId | slice:row.bikeId.length-8:row.bikeId.length}}</button> -->
							</td>
						</ng-container>

						<ng-container matColumnDef="sourceRegistrationId">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Original Registration</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span title="View Transfer Request Details." i18n-title type="button">{{row.sourceRegistrationId | slice:row.sourceRegistrationId.length-8:row.sourceRegistrationId.length}}</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="destinationEmail">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>New Owner's Email</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span title="View Destination Email" i18n-title type="button">{{row.destinationEmail}}</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="status">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Status</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span title="Status">{{row.status}}</span>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: tableColumns; let i = dataIndex;"></tr>
					</table>
				</div>

				<mat-paginator 
					[length]="list.length"
					[pageSize]="pageSize"
					[pageIndex]="pageIndex"
					[pageSizeOptions]="[10, 25, 50]"
					(page)="paginateRequests($event)"
				></mat-paginator>
			</mat-card>
		</div>
	</div>
</div>
